import {
  ControlledCheckbox
} from '@@viewCommonComponents/controlled/index.js';
import React, { useEffect } from 'react';
import Title from '@@viewCommonComponents/Title.jsx';
import { applySpec, prop, path, gte, lte, pathOr, propOr, equals } from 'ramda';
import { offerCodeEnum } from '@@viewEnums';
import { parseDate } from '@@viewHelpers/validations';

const CustomerInformationExtraForm = ({ form, legalIndicators }) => {
  const {
    customerBirthDate,
    customerAnnualIncome,
    offerEffectDate,
    markUpLevel,
    offerCode
  } = applySpec({
    customerBirthDate: path(['customer', 'birthDate']),
    customerAnnualIncome: path(['customer', 'finances', '0', 'annualIncome']),
    offerEffectDate: prop('offerEffectDate'),
    offerCode: prop('offerCode'),
    markUpLevel: path(['markups', '0', 'level'])
  })(form.getValues());

  const consents = form.watch('consents');
  const markUps = form.watch('markups');

  useEffect(() => {
    consents.forEach((consent, index) => {
      form.setValue(
        `consents.${index}.level`,
        JSON.parse(propOr('false', 'level', consent))
      );
    });
    form.setValue(
      'markups.0.level',
      JSON.parse(pathOr('false', [0, 'level'], markUps))
    );
  }, []);

  const birth = parseDate(customerBirthDate);
  const effect = parseDate(offerEffectDate);

  const nbPass = customerAnnualIncome / legalIndicators.PASS;

  const displayMarkupQuestion =
    birth.isValid() && effect.isValid() &&
    gte(nbPass, 0.5) && lte(nbPass, 2) && effect.year() - birth.year() < 56;
  return (
    <>
      {equals(offerCode, offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION) && (
        <>
          {displayMarkupQuestion && (
            <ControlledCheckbox
              name="markups.0.level"
              label={
                'Je déclare sur l’honneur, être en bon état de santé et ne pas être atteint(e), à ma connaissance, d’une maladie grave. Je certifie sincères et véritables les indications ci-dessus et déclare avoir pris connaissance du fait que toute réticence ou fausse déclaration de ma part entraînerait la nullité de la présente adhésion.'
              }
              form={form}
            />
          )}
          {!markUpLevel && (
            <>
              <Title className={'text-lg leading-4 w-full md:!w-[100%]'}>
                {'L’acceptation de votre adhésion est conditionnée au respect des formalités médicales définies dans le document joint à la présente que nous vous invitons à consulter.\n' +
                  'A ce titre, nous vous remercions de compléter les éléments ci-dessous :'}
              </Title>
              <ControlledCheckbox
                name="consents.0.level"
                label={
                  'J’accepte de renseigner le questionnaire médical et à me soumettre le cas échéant à des examens médicaux nécessaires à l’adhésion au contrat'
                }
                form={form}
              />
              <ControlledCheckbox
                name="consents.1.level"
                label={
                  'Je consens explicitement à ce que des données de santé soient transmises au médecin conseil de GENERATION et au personnel habilité de l\'assureur pour le cas où elles sont nécessaires à la réalisation de l’adhésion, comme prévu au contrat.'
                }
                form={form}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default CustomerInformationExtraForm;
